var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vl-common-app"},[_c('iframe',{staticClass:"app-content",style:({height: _vm.iframeHeight + 'px'}),attrs:{"src":_vm.appCenterUrl,"allow":"camera; geolocation; microphone","allowtransparency":"true","id":"appCenterIframe","name":"appCenterIfr","allowpaymentrequest":"true","allowfullscreen":"true","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }